export interface ScreenSort {
    screenId: string;
    columnId: string;
    direction: 'ASC' | 'DESC';
}

/**
 * The sort that applies to a screen. The table stays mounted when the route
 * moves to another screen, and a sort set on the previous one names columns
 * the new one does not have.
 */
export const sortOfScreen = (sort: ScreenSort | null, screenId: string): ScreenSort | null =>
    sort?.screenId === screenId ? sort : null;

/** A click on a column header: unsorted → ASC → DESC → unsorted. */
export const toggleScreenSort = (sort: ScreenSort | null, screenId: string, columnId: string): ScreenSort | null => {
    const current = sortOfScreen(sort, screenId);
    if (current?.columnId !== columnId) {
        return {screenId, columnId, direction: 'ASC'};
    }
    return current.direction === 'ASC' ? {screenId, columnId, direction: 'DESC'} : null;
};
